<template>
    <div class="container-fluid form-container ias-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Intruder Alarm Service Report / Certificate
                </h1>
            </div>
        </div>
        <form
            action=""
            class="ias-form"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Job Details</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                                @change="siteChanged()"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="'site_' + site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="job_id">Job No.</label>
                            <select
                                v-if="jobs"
                                name="job_id"
                                id="job_id"
                                v-model="form.job_id"
                                class="form-control"
                                placeholder="Select a job"
                                :disabled="jobs.length < 1"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select a job
                                </option>
                                <option
                                    v-for="job in jobs"
                                    :key="'job_' + job.id"
                                    :value="job.id"
                                >
                                    {{ job.id }}: {{ job.name }}
                                </option>
                            </select>
                            <error
                                name="job_id"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="po_number">Purchase Order No.</label>
                            <input
                                type="text"
                                id="po_number"
                                name="po_number"
                                v-model="form.po_number"
                                placeholder="Purchase Order No."
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="po_number"
                            />
                        </div>
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="customer_order_no">Document No.</label>
                            <input
                                type="text"
                                id="doc_no"
                                name="doc_no"
                                v-model="form.doc_no"
                                placeholder="Document Number"
                                class="form-control"
                            >
                            <error
                                name="doc_no"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>General</h3>
                        </div>
                    </div>

                    <select-row
                        id="signed_in"
                        v-model="form.signed_in"
                        label="Have You Signed In?"
                        :options="['Yes', 'No signing in book', 'Not required']"
                    />

                    <select-row
                        id="require_rams"
                        v-model="form.require_rams"
                        label="Does the Customer Require our (RAMS) Risk Assessment & Method Statement?"
                        :options="['No', 'Office sent', 'Completed on site']"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>System Details</h3>
                        </div>
                    </div>
                    <select-row
                        id="service_type"
                        v-model="form.service_type"
                        label="What Service are you carrying out?"
                        :options="['Full New Service / System Take Over', '6 Monthly Routine Service', 'Remote Log In Service']"
                    />

                    <select-row
                        id="alarm_grade"
                        v-model="form.alarm_grade"
                        label="Intruder alarm grade system type"
                        :options="['G1', 'G2', 'G3', 'G4']"
                    />

                    <text-row
                        id="main_cp_location"
                        v-model="form.main_cp_location"
                        label="Main control panel location:"
                    />

                    <text-row
                        id="panel_master_code"
                        v-model="form.panel_master_code"
                        label="Panel master code:"
                    />

                    <text-row
                        id="panel_engineer_code"
                        v-model="form.intruder_panel_engineer_code"
                        label="Panel engineer code:"
                    />

                    <checkbox-row
                        id="clock_correct"
                        v-model="form.clock_correct"
                        label="The clock as been checked for correct time &amp; date, and adjusted if necesssary"
                    />

                    <select-row
                        id="system_monitor_type"
                        v-model="form.system_monitor_type"
                        label="System monitoring type"
                        :options="['Bells only', 'Auto dialer', 'Monitored - keyholder', 'Monitored - police']"
                    />

                    <checkbox-row
                        id="interconnections_labeled"
                        v-model="form.interconnections_labeled"
                        label="Are all interconnections labeled at the CIE, Power supply units, expanders Keypads &amp; Junction Boxes?"
                    />

                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-8">
                            <label for="entry_routes_correct">Are entry route(s) set for correct operation &amp; Time in
                                secs</label>
                        </div>
                        <div class="col-xs-12 col-sm-3 col-md-2 mb-sm-1">
                            <div class="input-group">
                                <input
                                    type="number"
                                    step="1"
                                    min="0"
                                    class="form-control"
                                    v-model="form.entry_routes_secs"
                                >
                                <span class="input-group-text">secs</span>
                            </div>
                            <error
                                name="entry_routes_secs"
                                :errors="errors"
                            />
                        </div>
                        <div class="col-xs-12 col-sm-3 col-md-2 text-right">
                            <label class="form-check-label">
                                <input
                                    type="radio"
                                    name="entry_routes_correct"
                                    id="entry_routes_correct"
                                    v-model="form.entry_routes_correct"
                                    value="Yes"
                                >
                                Yes
                            </label>
                            <label class="form-check-label">
                                <input
                                    type="radio"
                                    name="entry_routes_correct"
                                    v-model="form.entry_routes_correct"
                                    value="No"
                                >
                                No
                            </label>

                            <error
                                name="entry_routes_correct"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-8">
                            <label for="exit_routes_correct">Are exit route(s) set for correct operation &amp; Time in
                                secs</label>
                        </div>
                        <div class="col-xs-12 col-sm-3 col-md-2 mb-sm-1">
                            <div class="input-group">
                                <input
                                    type="number"
                                    step="1"
                                    min="0"
                                    class="form-control"
                                    v-model="form.exit_routes_secs"
                                >
                                <span class="input-group-text">secs</span>
                            </div>
                            <error
                                name="exit_routes_secs"
                                :errors="errors"
                            />
                        </div>
                        <div class="col-xs-12 col-sm-3 col-md-2 text-right">
                            <label class="form-check-label">
                                <input
                                    type="radio"
                                    name="exit_routes_correct"
                                    id="exit_routes_correct"
                                    v-model="form.exit_routes_correct"
                                    value="Yes"
                                >
                                Yes
                            </label>
                            <label class="form-check-label">
                                <input
                                    type="radio"
                                    name="exit_routes_correct"
                                    v-model="form.exit_routes_correct"
                                    value="No"
                                >
                                No
                            </label>
                            <error
                                name="exit_routes_correct"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <text-row
                        id="no_keypads"
                        v-model="form.no_keypads"
                        label="Number of keypads on the system:"
                        type="number"
                        step="1"
                        min="0"
                    />

                    <text-row
                        v-for="(keypad, index) in form.keypads"
                        :key="'keypad_' + index"
                        :id="'keypad_location[' + index + ']'"
                        v-model="keypad.location"
                        :label="'Keypad ' + (index + 1) + ' location:'"
                    />

                    <text-row
                        id="bell_delay"
                        v-model="form.bell_delay"
                        label="Bell delay in secs:"
                        type="number"
                        step="1"
                        min="0"
                    />

                    <text-row
                        id="no_bell_boxes"
                        v-model="form.no_bell_boxes"
                        label="Number of bell boxes in the system:"
                        type="number"
                        step="1"
                        min="0"
                    />

                    <div
                        class="row"
                        v-for="(bellBox, index) in form.bell_boxes"
                        :key="'bellbox_' + index"
                    >
                        <div class="col-xs-8 col-sm-6 col-md-3">
                            <label>Bell box #{{ index + 1 }} location:</label>
                        </div>
                        <div class="col-xs-4 col-sm-6 col-md-3">
                            <input
                                type="text"
                                placeholder="Type location..."
                                class="form-control"
                                v-model="bellBox.location"
                            >
                        </div>
                        <div class="col-xs-8 col-sm-6 col-md-3">
                            <label>#{{ index + 1 }} Tested and working:</label>
                        </div>
                        <div class="col-xs-4 col-sm-6 col-md-3">
                            <input
                                type="checkbox"
                                v-model="bellBox.tested"
                            >
                        </div>
                    </div>

                    <select-row
                        id="meets_documents"
                        label="Does the system installed meet the as-fitted documents?"
                        v-model="form.meets_documents"
                        :options="['Yes', 'No', 'No documents on site']"
                        wide
                    />

                    <checkbox-row
                        id="checked_for_tamper"
                        label="Have you checked at least one device for tamper?"
                        v-model="form.checked_for_tamper"
                    />

                    <checkbox-row
                        id="correct_env_condition"
                        label="Are all devices installed in the correct environmental conditions?"
                        v-model="form.correct_env_condition"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Power Supplies</h3>
                        </div>
                    </div>
                    <text-row
                        v-model="form.no_batteries"
                        type="number"
                        min="0"
                        step="1"
                        label="Number of batteries:"
                        id="no_batteries"
                    />
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Battery #</th>
                                        <th>Size (AMP)</th>
                                        <th>Battery Volts</th>
                                        <th>Battery Amps</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(battery, index) in form.batteries"
                                        :key="'battery_' + index"
                                    >
                                        <td>
                                            <input
                                                type="text"
                                                readonly
                                                :value="'Battery #' + (index + 1)"
                                                class="form-control"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                v-model="battery.size"
                                                min="0"
                                                step="0.01"
                                                class="form-control"
                                                placeholder="Size (AMP)"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                v-model="battery.volts"
                                                min="0"
                                                step="0.01"
                                                class="form-control"
                                                placeholder="Battery Volts"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                v-model="battery.amps"
                                                min="0"
                                                step="0.01"
                                                class="form-control"
                                                placeholder="Battery Amps"
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <text-row
                        type="number"
                        step="0.01"
                        min="0"
                        label="Charger voltage (V):"
                        v-model="form.charger_voltage"
                        id="charger_voltage"
                        @input="calculateBattery"
                    />

                    <text-row
                        type="number"
                        step="0.01"
                        min="0"
                        label="Quiescent Load In Amp (I1):"
                        v-model="form.quiescent_load"
                        id="quiescent_load"
                        @input="calculateBattery"
                    />

                    <text-row
                        type="number"
                        step="0.01"
                        min="0"
                        label="Alarm Load In Amp (I2):"
                        v-model="form.alarm_load"
                        id="alarm_load"
                        @input="calculateBattery"
                    />

                    <text-row
                        type="number"
                        step="0.01"
                        min="0"
                        label="Quiescent Alarm Grade Time T1:"
                        v-model="form.quiescent_alarm_grade"
                        id="quiescent_alarm_grade"
                        @input="calculateBattery"
                    />

                    <text-row
                        type="number"
                        step="0.01"
                        min="0"
                        label="Battery Calculation [(I1xT1)+I2]x1.25:"
                        v-model="form.battery_calculation"
                        readonly
                        id="battery_calculation"
                    />

                    <checkbox-row
                        v-model="form.psu_tested"
                        label="Have external PSU batteries been tested?"
                        id="ps_tested"
                        :options="['Yes', 'No', 'N/A']"
                    />

                    <checkbox-row
                        v-model="form.standby_capacity"
                        label="Do the batteries installed have adequate standby capacity for the system?"
                        id="standby_capacity"
                    />

                    <checkbox-row
                        v-model="form.batteries_marked"
                        label="All batteries in CIE/PC(s) are marked with date of installation"
                        id="batteries_marked"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>System Test</h3>
                        </div>
                    </div>
                    <intruder-alarm-zones v-model="form.testItems" />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Monitoring and Panel Downloads</h3>
                        </div>
                    </div>

                    <checkbox-row
                        label="Is the site monitored by a Monitoring Station (ARC)?"
                        id="monitoring_station"
                        v-model="form.monitoring_station"
                    />

                    <select-row
                        v-show="form.monitoring_station === 'Yes'"
                        label="Is the site monitored by Sia or Fast Format?"
                        id="sia_fast_format"
                        v-model="form.sia_fast_format"
                        :options="['Sia', 'Fast Format']"
                    />

                    <checkbox-row
                        v-show="form.monitoring_station === 'Yes'"
                        :label="'Is the site monitored by '+companyName+'?'"
                        id="diamond_fire_monitored"
                        v-model="form.diamond_fire_monitored"
                    />

                    <text-row
                        v-show="form.diamond_fire_monitored === 'Yes'"
                        type="number"
                        step="1"
                        v-model="form.chip_number"
                        label="What is the Chip Number"
                        id="chip_number"
                    />

                    <checkbox-row
                        v-show="form.diamond_fire_monitored === 'Yes'"
                        label="Have you checked keyholder details still remain correct?"
                        id="keyholder_details_correct"
                        v-model="form.keyholder_details_correct"
                    />

                    <div v-show="form.sia_fast_format === 'Fast Format'">
                        <div class="row">
                            <div class="col-12">
                                <label>Please enter Fast Format Channels:</label>
                            </div>
                        </div>
                        <div
                            class="row"
                            v-for="n in 8"
                            :key="'ff_' + n"
                        >
                            <div class="col-sm-1">
                                {{ n }}.
                            </div>
                            <div class="col-sm-11">
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="form['fast_channel_' + n]"
                                >
                            </div>
                        </div>
                    </div>

                    <checkbox-row
                        label="Have signals been tested through to monitoring station?"
                        id="signals_tested"
                        v-model="form.signals_tested"
                    />

                    <checkbox-row
                        label="Has the panel data and configuration download been completed?"
                        id="panel_downloaded"
                        v-model="form.panel_downloaded"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Observations and Recommendations</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <textarea
                                rows="4"
                                v-model="form.observations"
                                placeholder="Type here..."
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Logs &amp; Final Checks</h3>
                        </div>
                    </div>

                    <checkbox-row
                        v-model="form.log_book_updated"
                        label="Has the log book been updated?"
                        id="log_book_updated"
                    />

                    <checkbox-row
                        v-model="form.left_operational"
                        label="System left fully operational?"
                        id="left_operational"
                    />

                    <checkbox-row
                        v-model="form.left_fault_free"
                        label="System left fully fault free?"
                        id="left_fault_free"
                    />

                    <checkbox-row
                        v-model="form.reported"
                        label="Have all recommendations, outstanding issues and non-complances been recorded and reported to the responsible person?"
                        id="reported"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Notes</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <textarea
                                name="notes"
                                id="notes"
                                cols="30"
                                rows="10"
                                class="form-control"
                                placeholder="Type notes here..."
                                v-model="form.notes"
                            />
                            <error
                                name="notes"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Signoff</h3>
                            <p>
                                I declare that I am a competent person (CP) in Intruder alarm system maintence. All
                                equipment serviced &amp; returned to normal according to BS 9263.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">
                            <label class="top">Engineer Signature:</label>
                            <br>
                            <user-select
                                v-model="form.engineer_id"
                                :office="false"
                                :admins="false"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="engineer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.engineer_sign_date"
                                id="engineer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="engineer_sign_date"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <p>
                                Accepted, For and behalf of the user, by Responsible person (RP). I understand that the
                                system is operating as designed I understand that if any items, were shown to be
                                defective, the Intruder Alarm system may not comply with BS 9263
                            </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label class="top">Customer Signature:</label>
                            <br>
                            <signature
                                v-if="!form.customer_signature"
                                ref="customerSignature"
                            />
                            <img
                                v-if="form.customer_signature"
                                :src="form.customer_signature"
                                alt="Customer signature"
                            >
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_name"
                                class="top"
                            >Customer Name</label>
                            <br>
                            <input
                                type="text"
                                v-model="form.customer_sign_name"
                                id="customer_sign_name"
                                name="customer_sign_name"
                                placeholder="Customer Name"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="customer_sign_name"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.customer_sign_date"
                                id="customer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="customer_sign_date"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isSaving || isLoading"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isSaving || isLoading"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id && form.customer_id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <router-link
                                :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'office.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-briefcase" /> View Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import DatePicker from "../DateTimePickerComponent.vue";
import CustomerSearch from "../CustomerSearch.vue";
import Service from "../../services/FormService";
import * as moment from "moment";
import Signature from "../SignatureComponent.vue";
import AuthService from "../../services/AuthService";
import FormService from "../../services/FormService";
import JobService from "../../services/JobService";
import UsersService from "../../services/UsersService";
import UsesErrors from "../../mixins/UsesErrors";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import Sortables from '../../mixins/Sortables';
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";
import SelectRow from './parts/SelectRowComponent';
import CheckboxRow from './parts/CheckboxRowComponent.vue';
import TextRow from './parts/TextRowComponent';
import SiteService from '../../services/SitesService';
import IntruderAlarmZones from './parts/IntruderAlarmZones';

export default {
    components: {
        CustomerSearch,
        DatePicker,
        Signature,
        SelectRow,
        CheckboxRow,
        TextRow,
        IntruderAlarmZones,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
        Sortables,
        UsesFormRouteQuery,
    ],
    props: {
        formId: {
            default: () => null
        },
    },
    data() {
        return {
            officeStaff: [],
            changed: false,
            sites: [],
            customerSignature: null,
            jobs: [],
            form: {
                type: "intruder_alarm_service",
                customer: {
                    company_name: "",
                },
                job_id: null,
                site_id: '',
                materials: [],
                engineer_sign_date: moment(),
                customer_sign_date: moment(),
                no_engineers_attended: 1,
                keypads: [],
                bell_boxes: [],
                batteries: [],
                testItems: [
                    {
                        function: null,
                        tested: 'No',
                    }
                ],
            },
            materials: [],
            token: null,
            companyName: window.SystemSettings.company_name,
        };
    },
    computed: {
        canDelete() {
            return AuthService.user.admin_access || AuthService.user.office_access;
        },
        noOfKeypads() {
            return parseInt(this.form.no_keypads || '0');
        },
        noOfBellBoxes() {
            return parseInt(this.form.no_bell_boxes || '0');
        },
        noOfBatteries() {
            return parseInt(this.form.no_batteries || '0');
        },
    },
    watch: {
        noOfKeypads: {
            handler: 'keypadsChanged',
            immediate: true,
        },
        noOfBellBoxes: {
            handler: 'bellBoxesChanged',
            immediate: true,
        },
        noOfBatteries: {
            handler: 'batteriesChanged',
            immediate: true,
        },
    },
    mounted() {

        this.populateFormFromRouteQuery();

        if (this.$route.params.id) {
            const id = this.$route.params.id;
            this.loadForm(id);
        } else {
            FormService.nextNo().then(res => {
                this.form.doc_no = res.data;
            });
        }

        this.getOfficeStaff();
    },
    methods: {
        loadForm(id) {
            this.setLoading();
            FormService.get(id).then(res => {
                this.form = {...res.data};
                this.materials = this.form.materials ? this.form.materials : [];
                if (res.data.engineer_sign_date) {
                    this.form.engineer_sign_date = moment(res.data.engineer_sign_date);
                } else {
                    this.form.engineer_sign_date = moment();
                }
                if (res.data.customer_sign_date) {
                    this.form.customer_sign_date = moment(res.data.customer_sign_date);
                } else {
                    this.form.customer_sign_date = moment();
                }
                if (!this.form.testItems) {
                    this.form.testItems = [];
                }
                this.form.testItems = this.form.testItems.map(i => {
                    return {
                        ...i,
                        tested: i.tested === 'Yes' || i.tested === true,
                    }
                })
                if (!this.form.batteries) {
                    this.form.batteries = [];
                }
                // Handle the renaming of this field
                if (!this.form.intruder_panel_engineer_code) {
                    this.form.intruder_panel_engineer_code = this.form.panel_engineer_code;
                }
                this.getJobs();
                this.siteChanged();
            }, err => {
                this.setErrorMessage('Could not load form');
                console.error(err);
            }).then(() => {
                this.clearLoading();
            });
        },
        customerChanged(customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
            } else {
                this.form.customer_id = null;
            }
            if (customer && customer.sites) {
                if (!customer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                    this.siteChanged();
                }
            } else {
                this.form.site_id = '';
                this.siteChanged();
            }
            this.getJobs();
        },
        siteChanged() {
            this.loadSiteFormFields();
        },

        onJobLoadedFromRoute() {
            this.siteChanged();
            this.getJobs();
        },

        getJobs() {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({'filter[customer_id]': this.form.customer_id}).then(res => {
                this.jobs = res.data.data || [];
            }, err => {
                this.setErrorMessage('Could not load customer jobs');
                this.jobs = [];
            });
        },
        saveForm() {
            this.setSaving();
            this.clearErrors();
            if (this.$refs.customerSignature && !this.$refs.customerSignature.isEmpty()) {
                this.form.customer_signature = this.$refs.customerSignature.toPng();
            }
            let data = {...this.form};
            delete data['customer'];
            delete data['panel_engineer_code'];
            delete data['site'];
            delete data['job'];
            delete data['data'];

            if (this.form.id) {
                Service.update(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit('formSaved', res.data);
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            } else {
                Service.create(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        if (this.$route.path.includes('engineer/')) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        } else {
                            this.$router.push({
                                name: 'office.forms.edit',
                                params: {
                                    id: res.data.id
                                }
                            });
                        }
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            }
        },
        deleteForm() {
            if (confirm("Are you sure you want to delete this form?")) {
                Service.delete(this.form).then(
                    xhr => {
                        this.setInfoMessage("Form successfully deleted");
                        // TODO: Redirect to relavant page
                        this.$router.push({name: 'office.forms.search'});
                    },
                    error => {
                        this.setErrorMessage("Could not delete this form");
                        console.error(error);
                    }
                );
            }
        },
        getOfficeStaff() {
            return new Promise((fulfill, reject) => {
                UsersService.officeStaff().then(
                    xhr => {
                        this.officeStaff = xhr.data;
                        fulfill(xhr);
                    },
                    err => {
                        reject(err);
                    }
                );
            });
        },

        keypadsChanged() {
            if (this.noOfKeypads <= 0) {
                this.form.keypads = [];
                this.$forceUpdate();
                return;
            }
            if (this.form.keypads.length > this.noOfKeypads) {
                this.form.keypads = this.form.keypads.splice(0, this.noOfKeypads);
                this.$forceUpdate();
                return;
            }
            while (this.form.keypads.length < this.noOfKeypads) {
                this.form.keypads.push({
                    location: '',
                });
                this.$forceUpdate();
            }
        },

        bellBoxesChanged() {
            if (this.noOfBellBoxes <= 0) {
                this.form.bell_boxes = [];
                this.$forceUpdate();
                return;
            }
            if (this.form.bell_boxes.length > this.noOfBellBoxes) {
                this.form.bell_boxes = this.form.bell_boxes.splice(0, this.noOfBellBoxes);
                this.$forceUpdate();
                return;
            }
            while (this.form.bell_boxes.length < this.noOfBellBoxes) {
                this.form.bell_boxes.push({
                    location: '',
                    tested: false,
                });
                this.$forceUpdate();
            }
        },

        batteriesChanged() {
            if (this.noOfBatteries <= 0) {
                this.form.batteries = [];
                this.$forceUpdate();
                return;
            }
            if (this.form.batteries.length > this.noOfBatteries) {
                this.form.batteries = this.form.batteries.splice(0, this.noOfBatteries);
                this.$forceUpdate();
                return;
            }
            while (this.form.batteries.length < this.noOfBatteries) {
                this.form.batteries.push({
                    amps: '',
                    volts: '',
                });
                this.$forceUpdate();
            }
        },

        calculateBattery() {
            var i1 = parseFloat(this.form.quiescent_load);
            var i2 = parseFloat(this.form.alarm_load);
            var t1 = parseFloat(this.form.quiescent_alarm_grade);
            if (!i1 || !i2 || !t1) {
                this.form.battery_calculation = '';
                return;
            }

            this.form.battery_calculation = (((i1 * t1) + i2) * 1.25).toFixed(2);
        },

        loadSiteFormFields: function () {
            if (
                typeof this.form.site_id === "undefined" ||
                !this.form.site_id
            ) {
                this.site_devices = [];
                return;
            }

            SiteService.get(this.form.site_id).then(res => {
                if (res.data.form_fields) {
                    res.data.form_fields.forEach(field => {
                        if (!this.form.id) {
                            try {
                                this.form[field.name] = JSON.parse(field.value);
                            } catch (e) {
                                this.form[field.name] = field.value;
                            }
                        }
                    });
                    this.$forceUpdate();
                }

                if (res.data.fire_alarm_fields) {
                    this.form = {...res.data.fire_alarm_fields, ...this.form};
                }
            });
        },
    }
}
;
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/IntruderAlarmServiceForm.vue